module.exports = __webpack_public_path__ + "cleanpure.png?7ef0782db7909d84b88c31788136073d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/cleanpure.png
// module id = 227
// module chunks = 0